import { useMemo } from "react";

export const useUserResources = (user, activeWineryId) => {
  return useMemo(() => {
    if (!user?.rbac_roles || !activeWineryId) return {};

    const resources = {};

    user.rbac_roles
      .filter(r => Number(r.winery_id) === Number(activeWineryId))
      .forEach(role => {
        Object.entries(role.permissions || {}).forEach(
          ([resource, perms]) => {
            if (!resources[resource]) {
              resources[resource] = {
                read: false,
                write: false,
                delete: false,
                export: false,
              };
            }

            resources[resource].read   ||= perms.read;
            resources[resource].write  ||= perms.write;
            resources[resource].delete ||= perms.delete;
            resources[resource].export ||= perms.export;
          }
        );
      });

    return resources;
  }, [user, activeWineryId]);
};
